import React from "react";
import ReactApexChart  from "react-apexcharts";

const AnalystChart = ({data}) => {

    const options = {
        series: [{
            name: 'Buy',
            data: [44, 55, 41, 37]
        }, {
            name: 'Hold',
            data: [53, 32, 33, 52]
        }, {
            name: 'Sell',
            data: [12, 17, 11, 9]
        }],
        chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: {
                show: false,
            }
        },
        
        stroke: {
            width: 1,
            colors: ['#fff']
        },
        
        xaxis: {
            categories: ["Sep", "Oct", "Nov", "Dec"]
        
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + "%"
                }
            }
        },
        fill: {
            opacity: 1
        },
        legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40
        },
        colors: ["#6993FF", "#1BC5BD", "#FFA800", "#F64E60", "#8950FC"]
    };
    
    return <ReactApexChart options={options} series={options.series} type="bar" height="300"/>

}

export default AnalystChart;